export default __webpack_public_path__ + "static/media/MicroBit.7e31b798.webp";